import { Grid, Button } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import FilterTable from "../../components/table/FilterTable";
import DefaultPageWrapper from "../../components/wrapper/DefaultPageWrapper";
import LoaderWrapper from "../../components/wrapper/LoaderWrapper";
import { USER_ROLES } from "../../helpers/constants";
import { useAccessControl } from "../../hooks/auth/useCheckPermission";
import usePaginationWithSearchParams from "../../hooks/usePaginationWithSearchParams";
import { useGetAllClauses } from "../../services/clausesService";
import { useBankings } from "../../services/bankingService";
import TableService from "../../services/tableService";

import { CLAUSE_TABLE_NAME, useClauseTableFieldsConfig } from "./TableFieldsConfig";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { centerVericalAlignIconStyle } from "../../helpers/styles";
import { InvestmentFilter } from "../../components/common/InvestmentFilter";
import { AddClauseDialog } from "./AddClauseDialog";

import ClauseNavigationBar from "./ClausesNavigationBar";

export default function ClausesAdminPanelPage(props) {
    const { hasAccess } = useAccessControl([USER_ROLES.SALES_MARKETING, USER_ROLES.ADMIN]);

    if (!hasAccess){
        return null
    }

    const { t } = useTranslation();
    const CLAUSE_FIELD_CONFINGS = useClauseTableFieldsConfig();

    const [dataLocal, setDataLocal] = useState([]);
    const [hiddenColumnsForTables, setHiddenColumnsForTables] = useState([]);
    const [columnsOrdersForTables, setColumnsOrdersForTables] = useState([]);
    const [recordsCount, setRecordsCount] = useState(0);

    const {
        resetPageNumber,
        searchParams,
        setSearchParams,
        page: dataPage,
        pageSize: dataPageSize,
        handleChangePageWithSearchParams: handleChangeDataPage,
        handleChangePageSizeWithSearchParams: handleChangeDataPageSize,
    } = usePaginationWithSearchParams();

    const { data: clauseData, isLoading } = useGetAllClauses(searchParams);

    useEffect(() => {
        if (clauseData?.results) {
            setDataLocal(clauseData.results);
            setRecordsCount(clauseData.count);
        }
    }, [clauseData, dataPage, dataPageSize]);

    const onClickButton = useCallback((e, id) => {
        e.stopPropagation();
    }, []);

    const clauseDataExportHeaders = useMemo(() => {
        return TableService.getTableExportHeaders(
            CLAUSE_FIELD_CONFINGS, // @ts-ignore
            hiddenColumnsForTables?.[CLAUSE_TABLE_NAME] || [], // @ts-ignore
            columnsOrdersForTables?.[CLAUSE_TABLE_NAME] || [],
        );
    }, [CLAUSE_FIELD_CONFINGS, hiddenColumnsForTables, columnsOrdersForTables]);

    const data = useMemo(
        () =>
            TableService.getPreparedDataForCollapsibleTable(
                CLAUSE_FIELD_CONFINGS,
                dataLocal, // @ts-ignore
                hiddenColumnsForTables?.[CLAUSE_TABLE_NAME]
                    ? // @ts-ignore
                      hiddenColumnsForTables?.[CLAUSE_TABLE_NAME]
                    : [], // @ts-ignore
                columnsOrdersForTables?.[CLAUSE_TABLE_NAME]
                    ? // @ts-ignore
                      columnsOrdersForTables?.[CLAUSE_TABLE_NAME]
                    : [],
                onClickButton,
            ),
        [
            CLAUSE_FIELD_CONFINGS,
            dataLocal,
            hiddenColumnsForTables,
            columnsOrdersForTables,
            onClickButton,
        ],
    );

    const tableComponent = () => (
        <FilterTable
            // @ts-ignore
            data={data}
            countRecords={recordsCount}
            resetPageNumber={resetPageNumber}
            style={{ maxHeight: "60vh" }}
            headersConfig={TableService.orderColumns(
                TableService.hideHiddenColumns(
                    CLAUSE_FIELD_CONFINGS, // @ts-ignore
                    hiddenColumnsForTables?.[CLAUSE_TABLE_NAME] || [],
                ),
                // @ts-ignore
                columnsOrdersForTables?.[CLAUSE_TABLE_NAME] || [],
            )}
            showCleanFilterIcon={true}
            showContextMenu={false}
            showExportToFileButton={false}
            hideFiltersIconCol={true}
            // exportToFileUrl={"cusomers/bankings/export/"}
            // exportToFileSearchParams={searchParams}
            // exportToFileHeaders={clauseDataExportHeaders}
            // exportToFileFileName={`${t("bankings.exportBankingsFileName")}.xlsx`}
            showDetailsIcon={false}
            showCheckbox={false}
            page={dataPage}
            onPageChange={handleChangeDataPage}
            rowsPerPage={dataPageSize}
            onRowsPerPageChange={handleChangeDataPageSize}
            setDataLocal={setDataLocal}
            isLoading={isLoading}
        />
    );

      const { openDialog: openAddClauseDialog } = useDialogBetter();
    
      const handleOpenAddClauseDialog = (e) => {
        openAddClauseDialog({
          Component: AddClauseDialog,
        });
      };


    return (
        // @ts-ignore
        <DefaultPageWrapper tagTitle={t("headers.clauses")}>
            <Grid
                item
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                rowSpacing={1}
                columnSpacing={2}
            >
                <Grid item xs={12}>
                    < ClauseNavigationBar />
                </Grid>
                <Grid item xs={2}>
                    <Button fullWidth variant="contained" onClick={handleOpenAddClauseDialog}>
                        {t("page.clause_page.add_clause")}
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <LoaderWrapper showLoader={false}>{tableComponent()}</LoaderWrapper>
                </Grid>
            </Grid>
        </DefaultPageWrapper>
    );
}
